import { CSSProperties, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { PdfPreviewContent } from "./PdfPreviewContent";
import { BASE_URL, UPLOAD_IMAGES } from "../utils/constants";
import { useIES } from "../hooks/useIES";

// Objetos de estilo para manter o código limpo e consistente
const styles: { [key: string]: CSSProperties } = {
  container: {
    padding: "20px", 
    // fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#2c3e50",
    backgroundColor: "#fff",
    borderRadius: "0",
    width: "100%",
    margin: "0 auto"
  },
  header: {
    textAlign: "center",
    marginBottom: "25px",
    padding: "15px",
    borderBottom: "2px solid #3498db",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  logo: {
    width: "150px",
    height: "auto",
    marginBottom: "15px",
    // filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))"
  },
  title: {
    fontSize: "22px",
    fontWeight: "bold",
    margin: "5px 0 0",
    color: "#3498db"
  },
  subHeader: {
    textAlign: "center",
    marginBottom: "20px"
  },
  grid: {
    marginBottom: "30px",
    padding: "20px",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    backgroundColor: "#fff",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "15px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.03)"
  },
  gridLabel: {
    fontWeight: "600",
    color: "#3498db"
  },
  gridValue: {
    fontWeight: "500"
  },
  gridDivider: {
    margin: "12px 0",
    borderColor: "#ecf0f1"
  },
  tableContainer: {
    width: "100%",
    marginBottom: "20px",
    borderRadius: "0",
    overflow: "visible",
    boxShadow: "none",
    pageBreakInside: "avoid"
  },
  table: {
    width: "100%",
    // borderCollapse: "collapse",
    fontSize: "12px", 
    backgroundColor: "#fff",
    pageBreakInside: "avoid"
  },
  th: {
    backgroundColor: "#3498db",
    color: "#fff",
    border: "1px solid #2980b9",
    padding: "10px",
    textAlign: "left",
    fontWeight: "600"
  },
  td: { border: "1px solid #000", padding: "4px 6px" },
  evenRow: {
    backgroundColor: "#f5f9fe"
  },
  signatureContainer: {
    textAlign: "center",
    marginTop: "40px",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.03)"
  },
  signatureLine: {
    width: "300px",
    borderTop: "2px solid #3498db",
    margin: "0 auto 10px"
  },
  signatureText: {
    margin: "5px 0",
    fontSize: "16px",
    fontWeight: "500"
  },
  dateText: {
    fontSize: "14px",
    color: "#7f8c8d",
    marginTop: "8px",
    fontStyle: "italic"
  },
  statsContainer: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#edf7fd",
    padding: "12px 20px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
  },
  statBox: {
    textAlign: "center",
    padding: "10px 15px"
  },
  statNumber: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#3498db",
    margin: "0 0 5px 0"
  },
  statLabel: {
    fontSize: "14px",
    color: "#7f8c8d"
  }
};

export const StudentsList = () => {
  const studentsDataLS = localStorage.getItem("studentsData");
  const preloadedStudentsData = studentsDataLS ? JSON.parse(studentsDataLS) : undefined;
  const { IES, isLoading } = useIES();
  const studentsDataFromState = useSelector(
    (state: RootState) => state.student.students?.list
  );
  const studentsFiltersFromState = useSelector(
    (state: RootState) => state.student.students?.filters
  );
  const studentsData = preloadedStudentsData || studentsDataFromState;

  const filtersLS = localStorage.getItem("studentsFilters");
  const filters = filtersLS
    ? JSON.parse(filtersLS)
    : studentsFiltersFromState || {};

  const currentDate = new Date().toLocaleDateString("pt-PT");
  const userData = useSelector((state: RootState) => state.login.userData);

  useEffect(() => {
    localStorage.removeItem("pdfPreviewTypeData");
    localStorage.removeItem("studentsData");
    localStorage.removeItem("studentsFilters");
  }, []);
  const getFirstAndLastName = (fullName:string) => {
    const parts = fullName.trim().split(" ");
    if (parts.length === 1) return { firstName: fullName, lastName: "" };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1] };
    let firstName = parts.slice(0, parts.length - 1).join("    ");
    return {
      firstName,
      lastName: parts[parts.length - 1]
    };
  };
  return (
    <PdfPreviewContent>
      <div style={styles.container}>
        {/* Logo e Cabeçalho */}
        <div style={styles.header}>
          <img
             src={`${IES.LOGO}`}
            alt="IES Logo"
            style={styles.logo}
          />
          <h1 style={styles.title}>
            {filters?.University || IES.NAME}{" "}
            {filters?.Faculty ? `- ${filters.Faculty}` : ""}
          </h1>
          <p style={{ margin: "8px 0 0", color: "#7f8c8d", fontSize: "16px" }}>
          {filters?.Course} {filters?.Class} {filters?.Subject} {filters?.Level?`${filters?.Level}º Ano`:""} {filters?.Semester?`${filters?.Semester}º Semestre`:""} {filters?.Regime} {filters?.AcademicYear}
          </p>
        </div>

        {/* Estatísticas Resumidas */}
        {/* <div style={styles.statsContainer}> */}
          {/* <div style={styles.statBox}>
            <div style={styles.statNumber}>{filters?.TotalItems || 0}</div>
            <div style={styles.statLabel}>Total de estudantes</div>
          </div> */}
          {/* {filters?.TotalPages && (
            <div style={styles.statBox}>
              <div style={styles.statNumber}>{filters.PageNumber}/{filters.TotalPages}</div>
              <div style={styles.statLabel}>Páginas</div>
            </div>
          )} */}
          {/* {filters?.TotalOnPage && (
            <div style={styles.statBox}>
              <div style={styles.statNumber}>{filters.TotalOnPage}</div>
              <div style={styles.statLabel}>Nesta Lista</div>
            </div>
          )} */}
        {/* </div> */}

      

        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{...styles.th, width: "10%"}}>Ordem</th>
                <th style={{...styles.th, width: "25%"}}>Código</th>
                <th style={styles.th}>Nome</th>
                <th style={styles.th}>Apelido</th>
              </tr>
            </thead>
            <tbody>
              {studentsData &&
                studentsData.map((student: any, index: number) => {
                  const { firstName, lastName } = getFirstAndLastName(student.Fullname);
                  return (
                  <tr key={student.id+"_"+index} style={index % 2 === 0 ? styles.evenRow : {}}>
                    <td style={{...styles.td, textAlign: "center"}}>{index + 1}</td>
                    <td style={{...styles.td, fontWeight: "500"}}>{student.SchoolCode}</td>
                    <td style={{...styles.td}}>
                      {`${firstName}`}
                    </td>
                    <td style={{...styles.td}}>
                      {`${lastName}`}
                    </td>
                  </tr>)
})}
            </tbody>
          </table>
        </div>

        {/* Assinatura e Rodapé */}
        <div style={styles.signatureContainer}>
          <div style={styles.signatureLine}></div>
          <p style={styles.signatureText}>
            {userData?.Fullname || "Nome do Responsável"}
          </p>
          <p style={{margin: "3px 0", fontSize: "15px", color: "#3498db"}}>
            {userData?.Role || "Cargo"}
          </p>
          <p style={styles.dateText}>Documento gerado em: {currentDate}</p>
        </div>
      </div>
    </PdfPreviewContent>
  );
};

export default StudentsList;